import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dynamic-tab-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dynamic_tab_content = _resolveComponent("dynamic-tab-content")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, { spinning: _ctx.loading }, {
      default: _withCtx(() => [
        (_ctx.tabConfig && _ctx.customerData)
          ? (_openBlock(), _createBlock(_component_dynamic_tab_content, {
              key: 0,
              tabConfig: _ctx.tabConfig,
              customerData: _ctx.customerData
            }, null, 8, ["tabConfig", "customerData"]))
          : (_openBlock(), _createBlock(_component_a_empty, {
              key: 1,
              description: "暂无配置或数据"
            }))
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}